module.exports = __webpack_public_path__ + "static/img/10.a9eb081.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/2/eng/10.png
// module id = yLJu
// module chunks = 0